import React from 'react'
import classes from './AdminNavbar.module.css'

const AdminNavbar = (props) => {
    return (
        <div className={classes.main}>
            <h2>electroperedachi</h2>
        </div>
    )
}

export default AdminNavbar